import { createStore } from 'vuex'
import menu from "./modules/menu"
import layout from "./modules/layout"
import language from "./modules/language"
import autenticacion from "./modules/autenticacion"
import destinatarios from "./modules/destinatarios"
import roles from "./modules/roles"
import configuracion from "./modules/configuracion"
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    menu,
    layout,
    language,
    autenticacion,
    destinatarios,
    roles,
    configuracion,
  }
})
